import { gql } from '@apollo/client'

// ==================== USER MUTATIONS ====================

export const createOneCredit = gql`
    mutation CreateOneCredit($date: String!, $userId: String!, $amount: Float!) {
        createOneCredit(date: $date, userId: $userId, amount: $amount) {
            amount
            id
        }
    }
`

export const updateUser = gql`
    mutation UpdateUser($userId: String!, $email: String, $role: Role, $isPremium: Boolean) {
        updateUser(userId: $userId, email: $email, role: $role, isPremium: $isPremium) {
            id
        }
    }
`

export const Login = gql`
    mutation Login($email: String!, $password: String!) {
        login(email: $email, password: $password) {
            user {
                id
            }
            token
        }
    }
`

export const userTransfer = gql`
    mutation UserTransfer($destinationId: String!, $sourceId: String!) {
        userTransfer(destinationId: $destinationId, sourceId: $sourceId)
    }
`

export const deleteUserData = gql`
    mutation DeleteUserData($userId: String!) {
        deleteUserData(userId: $userId) {
            success
            message
            deletedItems
        }
    }
`

export const sendFcm = gql`
    mutation SendFcm($message: String!, $title: String!, $fcmId: String!) {
        sendFcm(message: $message, title: $title, fcmId: $fcmId)
    }
`

// ==================== AUDIO MUTATIONS ====================

export const deleteAudioAdmin = gql`
    mutation DeleteAudioAdmin($audioId: String!) {
        deleteAudioAdmin(audioId: $audioId)
    }
`

export const updateAudioStatus = gql`
    mutation UpdateAudioStatus($audioId: String!, $status: StatusEnum!) {
        updateAudioStatus(audioId: $audioId, status: $status) {
            id
            status
        }
    }
`

// ==================== MUSIC STYLE MUTATIONS ====================

export const createMusicStyle = gql`
    mutation CreateMusicStyle($name: String!, $icon: String!) {
        createMusicStyle(name: $name, icon: $icon) {
            id
            name
            icon
        }
    }
`

export const updateMusicStyle = gql`
    mutation UpdateMusicStyle($id: String!, $name: String, $icon: String) {
        updateMusicStyle(id: $id, name: $name, icon: $icon) {
            id
            name
            icon
        }
    }
`

export const deleteMusicStyle = gql`
    mutation DeleteMusicStyle($id: String!) {
        deleteMusicStyle(id: $id)
    }
`

// ==================== GENRE MUTATIONS ====================

export const createGenre = gql`
    mutation CreateGenre($name: String!, $icon: String!, $prompt: String!) {
        createGenre(name: $name, icon: $icon, prompt: $prompt) {
            id
            name
            icon
            prompt
        }
    }
`

export const updateGenre = gql`
    mutation UpdateGenre($id: String!, $name: String, $icon: String, $prompt: String) {
        updateGenre(id: $id, name: $name, icon: $icon, prompt: $prompt) {
            id
            name
            icon
            prompt
        }
    }
`

export const deleteGenre = gql`
    mutation DeleteGenre($id: String!) {
        deleteGenre(id: $id)
    }
`

// ==================== CREDIT MUTATIONS ====================

export const updateCredit = gql`
    mutation UpdateCredit($creditId: String!, $expiryDate: DateTime, $amount: Float) {
        updateCredit(creditId: $creditId, expiryDate: $expiryDate, amount: $amount) {
            id
        }
    }
`

// Removed updateCreditConfig - use updateSystem instead

// ==================== CREDIT PRODUCT MUTATIONS ====================

export const createCreditProduct = gql`
    mutation CreateCreditProduct($input: CreateCreditProductInput!) {
        createCreditProduct(input: $input) {
            id
            name
            amount
            startDate
            endDate
            limit
            price
            type
            createdAt
            updatedAt
            creditCount
            isActive
            isExpired
            isUpcoming
        }
    }
`

export const updateCreditProduct = gql`
    mutation UpdateCreditProduct($input: UpdateCreditProductInput!, $updateCreditProductId: String!) {
        updateCreditProduct(input: $input, id: $updateCreditProductId) {
            id
            name
            amount
            startDate
            endDate
            limit
            price
            type
            createdAt
            updatedAt
            creditCount
            isActive
            isExpired
            isUpcoming
        }
    }
`

export const deleteCreditProduct = gql`
    mutation DeleteCreditProduct($id: String!) {
        deleteCreditProduct(id: $id)
    }
`

// ==================== SYSTEM MUTATIONS ====================

export const updateSystem = gql`
    mutation UpdateSystem($id: String!, $systemType: SystemTypeEnum!, $creditCost: Int) {
        updateSystem(id: $id, systemType: $systemType, creditCost: $creditCost) {
            id
            type
            creditCost
            createdAt
            updatedAt
        }
    }
`

// ==================== TOOL MUTATIONS ====================

export const createTool = gql`
    mutation CreateTool($input: CreateStudioInput!) {
        createTool(input: $input) {
            id
            name
            imageType
            bannerUrl
            videoUrl
            rowNumber
            templateId
            description
            prompt
            isFeatured
            duration
            categoryId
            cost
            provider
            createdAt
            updatedAt
            videoCount
            badgeText
            badgeIcon
            badgeTextColor
            badgeBackgroundColor
            category {
                id
                name
            }
            webmUrl
            webpUrl
            aspectRatios {
                id
                width
                height
                name
                aspectRatioX
                aspectRatioY
                createdAt
                updatedAt
                toolId
            }
        }
    }
`

export const updateTool = gql`
    mutation UpdateTool($input: UpdateStudioInput!, $updateToolId: String!) {
        updateTool(input: $input, id: $updateToolId) {
            id
            name
            imageType
            bannerUrl
            videoUrl
            rowNumber
            templateId
            description
            prompt
            isFeatured
            duration
            categoryId
            cost
            provider
            createdAt
            updatedAt
            videoCount
            badgeText
            badgeIcon
            badgeTextColor
            badgeBackgroundColor
            category {
                id
                name
            }
            webmUrl
            webpUrl
            aspectRatios {
                id
                width
                height
                name
                aspectRatioX
                aspectRatioY
                createdAt
                updatedAt
                toolId
            }
        }
    }
`

export const deleteTool = gql`
    mutation DeleteTool($deleteToolId: String!) {
        deleteTool(id: $deleteToolId) {
            id
            name
            imageType
            bannerUrl
            videoUrl
            rowNumber
            templateId
            description
            prompt
            isFeatured
            duration
            categoryId
            cost
            provider
            createdAt
            updatedAt
            videoCount
            webmUrl
            webpUrl
            aspectRatios {
                id
                width
                height
                name
                aspectRatioX
                aspectRatioY
                createdAt
                updatedAt
                toolId
            }
        }
    }
`

// ==================== FILE UPLOAD MUTATIONS ====================

export const getSignedUrl = gql`
    mutation GetSignedUrl($fileName: String!) {
        getSignedUrl(fileName: $fileName) {
            id
            url
            contentType
        }
    }
`

export const getObjectUrl = gql`
    mutation GetObjectUrl($eTag: String!, $key: String!) {
        getObjectUrl(eTag: $eTag, key: $key)
    }
`

// ==================== EXPLORE CATEGORY MUTATIONS ====================

export const createExploreCategory = gql`
    mutation CreateExploreCategory($input: CreateExploreCategoryInput!) {
        createExploreCategory(input: $input) {
            id
            name
            order
            isActive
        }
    }
`

export const updateExploreCategory = gql`
    mutation UpdateExploreCategory($id: String!, $input: UpdateExploreCategoryInput!) {
        updateExploreCategory(id: $id, input: $input) {
            id
            name
            order
            isActive
        }
    }
`

export const deleteExploreCategory = gql`
    mutation DeleteExploreCategory($id: String!) {
        deleteExploreCategory(id: $id)
    }
`

// ==================== EXPLORE AUDIO MUTATIONS ====================

export const createExploreAudio = gql`
    mutation CreateExploreAudio($input: CreateExploreAudioInput!) {
        createExploreAudio(input: $input) {
            id
            name
            categoryId
            audioUrl
            imageUrl
            prompt
            lyrics
            order
            isActive
        }
    }
`

export const updateExploreAudio = gql`
    mutation UpdateExploreAudio($id: String!, $input: UpdateExploreAudioInput!) {
        updateExploreAudio(id: $id, input: $input) {
            id
            name
            categoryId
            audioUrl
            imageUrl
            prompt
            lyrics
            order
            isActive
        }
    }
`

export const deleteExploreAudio = gql`
    mutation DeleteExploreAudio($id: String!) {
        deleteExploreAudio(id: $id)
    }
`

// ============== VOCAL MUTATIONS ==============

export const CREATE_VOCAL = gql`
    mutation CreateVocal($input: CreateVocalInput!) {
        createVocal(input: $input) {
            success
            message
            vocal {
                id
                vocalUrl
                vocalGender
                title
                duration
                isVisible
            }
        }
    }
`

export const UPDATE_VOCAL = gql`
    mutation UpdateVocal($id: ID!, $input: UpdateVocalInput!) {
        updateVocal(id: $id, input: $input) {
            id
            vocalUrl
            vocalGender
            title
            duration
            isVisible
        }
    }
`

export const DELETE_VOCAL = gql`
    mutation DeleteVocal($id: ID!) {
        deleteVocal(id: $id)
    }
`

export const GET_PRESIGNED_URL_FOR_VOCAL = gql`
    mutation GetPresignedUrlForVocal($filename: String!, $contentType: String!) {
        getPresignedUrlForVocal(filename: $filename, contentType: $contentType) {
            success
            uploadUrl
            fileUrl
            message
        }
    }
`

export const GET_PRESIGNED_URL_FOR_INSTRUMENTAL = gql`
    mutation GetPresignedUrlForInstrumental($filename: String!, $contentType: String!) {
        getPresignedUrlForInstrumental(filename: $filename, contentType: $contentType) {
            success
            uploadUrl
            fileUrl
            message
        }
    }
`

export const GENERATE_AUDIO_WITH_VOCAL = gql`
    mutation GenerateAudioWithVocal($input: GenerateAudioWithVocalInput!) {
        generateAudioWithVocal(input: $input) {
            success
            message
            audio {
                id
                status
                title
            }
        }
    }
`

